<template>
  <div class="app-layout__wrap">
    <MenuIcon @click="toggleCollapse" class="app-layout__sidenav-collapse-btn"/>
    <el-menu
      data-test="navbar"
      class="app-layout__sidenav"
      :class="{ 'app-layout__sidenav--visible': !isCollapse }">
      <el-menu-item
        @click="toggleCollapse"
        :index="'collapse'"
        :key="'collapse'">
        <MenuIcon/>
      </el-menu-item>
      <el-menu-item
        class="menu-item"
        v-for="item in menuItems"
        @click="pushRoute({ name: item.routeName })"
        :index="item.routePath"
        :key="item.key"
        :class="{ 'is-active': isRouteActive(item.routeName) }"
        :data-test="item.dataTest">
        <i :class="item.iconClass"></i>
        <span v-if="$t(item.i18n) !== 'Panier' || !numberOfItemsInCart">
          {{ $t(item.i18n) }}
        </span>
        <el-badge v-if="$t(item.i18n) === 'Panier' && numberOfItemsInCart"
                  :value="numberOfItemsInCart">
          <span>{{ $t(item.i18n) }}</span>
        </el-badge>
      </el-menu-item>
    </el-menu>
    <div class="app-layout__view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import MenuIcon from 'vue-material-design-icons/Menu.vue';

  export default {
    components: {
      MenuIcon,
    },
    data() {
      return {
        collapse: !this.$mq.above(768),
        menuItems: [
          {
            i18n: 'mainNav.helloWorldMenuItem',
            routeName: 'HelloWorld',
            key: '0',
            iconClass: 'el-icon-refrigerator',
            dataTest: 'navbar__hello-world-link',
          },
          {
            i18n: 'mainNav.cartMenuItem',
            routeName: 'Cart',
            key: '10',
            iconClass: 'el-icon-shopping-cart-2',
            dataTest: 'navbar__hello-world-link',
          },
          {
            i18n: 'mainNav.historyMenuItem',
            routeName: 'History',
            key: '15',
            iconClass: 'el-icon-notebook-1',
            dataTest: 'navbar__history-link',
          },
          {
            i18n: 'mainNav.logoutMenuItem',
            routeName: 'Logout',
            key: '5',
            iconClass: 'el-icon-switch-button',
            dataTest: 'navbar__logout-link',
          },
        ],
        test: 0,
      };
    },
    computed: {
      isCollapse() {
        return this.collapse;
      },
      numberOfItemsInCart() {
        return this.$store.getters['cart/numberOfItemsInCart'];
      },
    },
    methods: {
      toggleCollapse() {
        this.collapse = !this.collapse;
      },
      isRouteActive(name) {
        return name === this.$route.name;
      },
      pushRoute(route) {
        if (route.name !== this.$route.name) {
          this.$router.push(route);
        }
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/main.styl';

  $navbar-width = 64px;

  .app-layout__wrap {
    background: $primary-color;
    display: flex;
    min-height: 100vh;
    flex-direction: row;
    min-height: 100vh;
  }

  .app-layout__sidenav-collapse-btn {
    position: fixed;
    top: 20px;
    left: 20px;
    color: #fff;
    font-size: 2rem;
  }

  .app-layout__sidenav {
    width: $navbar-width;
    min-height: 100%;
    min-height: 100vh;
    display: none;
  }

  .app-layout__sidenav--visible {
    display: block;
  }

  .app-layout__sidenav:not(.el-menu--collapse) {
    width: 200px;
  }

  .app-layout__view {
    width: 100%;
    overflow-x: hidden;
  }

</style>
